import React from "react";
import Game from "./Game";
import {useLang} from "../context/LanguageContext";

const GroupsAccordion = ({ group, index }) => {
    const { t } = useLang();

    return (
        <details key={index} open className="border border-[#2ecc71] rounded-lg shadow-sm bg-[#2ecc71] mb-4">
            <summary className="cursor-pointer px-4 py-3 font-semibold text-lg">
                {t('txt.ticket')} {index + 1}
            </summary>
            <div className="p-1 space-y-2 bg-[#34495e] rounded-lg">
                {group.map((match, idx) => (
                    <Game key={idx} game={match} />
                ))}
            </div>
        </details>

    );
};

export default GroupsAccordion;